import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { buildHTMLStyles } from './utils/build-styles.mjs';
import { isCSSVariableName } from '../dom/utils/is-css-variable.mjs';
import { transformProps } from './utils/transform.mjs';
import { scrapeMotionValuesFromProps as _scrapeMotionValuesFromProps } from './utils/scrape-motion-values.mjs';
import { renderHTML } from './utils/render.mjs';
import { getDefaultValueType } from '../dom/value-types/defaults.mjs';
import { measureViewportBox } from '../../projection/utils/measure.mjs';
import { DOMVisualElement } from '../dom/DOMVisualElement.mjs';
function getComputedStyle(element) {
  return window.getComputedStyle(element);
}
var HTMLVisualElement = /*#__PURE__*/function (_DOMVisualElement) {
  function HTMLVisualElement() {
    var _this;
    _classCallCheck(this, HTMLVisualElement);
    _this = _callSuper(this, HTMLVisualElement, arguments);
    _this.type = "html";
    _this.renderInstance = renderHTML;
    return _this;
  }
  _inherits(HTMLVisualElement, _DOMVisualElement);
  return _createClass(HTMLVisualElement, [{
    key: "readValueFromInstance",
    value: function readValueFromInstance(instance, key) {
      if (transformProps.has(key)) {
        var defaultType = getDefaultValueType(key);
        return defaultType ? defaultType.default || 0 : 0;
      } else {
        var computedStyle = getComputedStyle(instance);
        var value = (isCSSVariableName(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
        return typeof value === "string" ? value.trim() : value;
      }
    }
  }, {
    key: "measureInstanceViewportBox",
    value: function measureInstanceViewportBox(instance, _ref) {
      var transformPagePoint = _ref.transformPagePoint;
      return measureViewportBox(instance, transformPagePoint);
    }
  }, {
    key: "build",
    value: function build(renderState, latestValues, props) {
      buildHTMLStyles(renderState, latestValues, props.transformTemplate);
    }
  }, {
    key: "scrapeMotionValuesFromProps",
    value: function scrapeMotionValuesFromProps(props, prevProps, visualElement) {
      return _scrapeMotionValuesFromProps(props, prevProps, visualElement);
    }
  }]);
}(DOMVisualElement);
export { HTMLVisualElement, getComputedStyle };